<template>
	<div @keydown.esc="closeMenu">
		<button
			class="relative w-48 h-48 flex justify-center items-center"
			:class="{ 'menu-button--active': showMenu }"
			@click="toggleMenu"
		>
			<span class="sr-only">
				{{ showMenu ? 'Collapse' : 'Expand' }} Menu
			</span>
			<div class="menu-icon menu-icon--top" />
			<div class="menu-icon menu-icon--bottom" />
		</button>
		<transition-menu>
			<div
				v-show="showMenu"
				class="fixed top-96 left-0 z-10 w-full h-content overflow-y-auto scrolling-touch bg-offwhite"
			>
				<slot />
			</div>
		</transition-menu>
	</div>
</template>

<script>
import TransitionMenu from '@/components/transition-menu.vue';

export default {
	components: {
		TransitionMenu,
	},
	data() {
		return {
			showMenu: false,
		};
	},
	mounted() {
		window.addEventListener( 'resize', this.handleResize );
		window.addEventListener( 'hashchange', this.closeMenu, false );
		window.dispatchEvent( new Event( 'resize' ) );
	},
	beforeDestroy() {
		window.removeEventListener( 'resize', this.handleResize );
		window.removeEventListener( 'hashchange', this.closeMenu, false );
	},
	methods: {
		toggleMenu() {
			// Clear url hash when opening menu (prevents unresponsive current anchor link)
			if ( ! this.showMenu ) {
				history.pushState( null, null, ' ' );
			}
			this.showMenu = ! this.showMenu;
		},
		closeMenu() {
			this.showMenu = false;
		},
		handleResize() {
			if ( window.innerWidth < 1024 ) {
				return;
			}
			this.showMenu = false;
		},
	},
};
</script>
